export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvSlide.vue?vue&type=template&id=65b85386&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvSlide.vue?vue&type=template&id=65b85386&lang=pug&
// module id = 168
// module chunks = 0 1